import { Box, Typography, Avatar, Card, CardContent, Divider, Stack } from '@mui/material';
import { formatNumber } from '../../lib/format';
import { hasBreakdown, followerCountLabel, platformColor, platformIconData } from '../../lib/social';
import BreakdownBars from '../../components/BreakdownBars';

function PublicSocialCard({ social }) {
  const stats = social.stats || {};
  const visibility = social.metricsVisibility || {};
  const insights = [
    { key: 'gender', label: 'Gender', visible: visibility.gender !== false, items: stats.genderBreakdown || [] },
    { key: 'ageRange', label: 'Age range', visible: visibility.ageRange !== false, items: stats.ageBreakdown || [] },
    { key: 'location', label: 'Location', visible: visibility.location !== false, items: stats.locationBreakdown || [] },
  ].filter((section) => section.visible && hasBreakdown(section.items));

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)',
        borderTop: 3,
        borderTopColor: platformColor(social.platform),
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Stack direction="row" spacing={1.5} sx={{ mb: 1.5, alignItems: 'flex-start' }}>
          <Avatar src={platformIconData(social.platform)} variant="rounded" />
          <Box sx={{ flexGrow: 1 }}>
            <Typography fontWeight={700}>{social.platform}</Typography>
            <Typography variant="body2" color="text.secondary">
              {social.handle}
            </Typography>
          </Box>
        </Stack>
        <Divider sx={{ mb: 1.5 }} />
        <Box>
          <Typography variant="h6">{formatNumber(social.followers)}</Typography>
          <Typography variant="caption" color="text.secondary">
            {followerCountLabel(social)}
          </Typography>
        </Box>
        {insights.length > 0 && (
          <Box sx={{ mt: 1.5, pt: 1.5, borderTop: 1, borderColor: 'divider' }}>
            <Typography variant="overline" color="text.secondary">
              Audience insights
            </Typography>
            <Stack spacing={1.5} divider={<Divider />} sx={{ mt: 0.5 }}>
              {insights.map((section) => (
                <Box key={section.key}>
                  <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
                    {section.label}
                  </Typography>
                  <BreakdownBars items={section.items} />
                </Box>
              ))}
            </Stack>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default PublicSocialCard;
